import { render, staticRenderFns } from "./BoxIndicadoresConformidade.vue?vue&type=template&id=33ccd37c&scoped=true&"
import script from "./BoxIndicadoresConformidade.vue?vue&type=script&lang=js&"
export * from "./BoxIndicadoresConformidade.vue?vue&type=script&lang=js&"
import style0 from "./BoxIndicadoresConformidade.vue?vue&type=style&index=0&id=33ccd37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ccd37c",
  null
  
)

export default component.exports